import { render } from "./Contacto.vue?vue&type=template&id=48ff8c6f&scoped=true"
import script from "./Contacto.vue?vue&type=script&lang=js"
export * from "./Contacto.vue?vue&type=script&lang=js"

import "./Contacto.vue?vue&type=style&index=0&id=48ff8c6f&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ff8c6f"]])

export default __exports__